// extracted by mini-css-extract-plugin
module.exports = {"component":"banner-notification-component--3Eu1L"};